module.exports = __webpack_public_path__ + "img/tabBg2.62d0b302.jpg";